import { render } from "./AllUsersPage.vue?vue&type=template&id=3a6ec594&scoped=true"
import script from "./AllUsersPage.vue?vue&type=script&lang=js"
export * from "./AllUsersPage.vue?vue&type=script&lang=js"

import "./AllUsersPage.vue?vue&type=style&index=0&id=3a6ec594&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6ec594"]])

export default __exports__